import * as React from "react";
const SvgSearch24Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 21,
        fill: "black",
        viewBox: "0 0 21 21"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M2 8.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0ZM8.5 0a8.5 8.5 0 1 0 5.262 15.176l5.53 5.531 1.415-1.414-5.531-5.531A8.5 8.5 0 0 0 8.5 0Z",
      clipRule: "evenodd"
    })
  );
export default SvgSearch24Px;
